import React, { useEffect, useState } from "react";
import { RESIGN_STATUS } from "../../utils/resignHelpers";
import "../common/ComplaintResponseModal.css";

const STATUS_OPTIONS = [
  { value: RESIGN_STATUS.APPROVED, label: "قبول الاستقالة" },
  { value: RESIGN_STATUS.REJECTED, label: "رفض الاستقالة" },
];

function toDateInputValue(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().split("T")[0];
}

function todayDateInputValue() {
  return new Date().toISOString().split("T")[0];
}

export default function ResignationStatusModal({
  isOpen,
  onClose,
  onSubmit,
  resignation,
}) {
  const [status, setStatus] = useState(RESIGN_STATUS.APPROVED);
  const [notes, setNotes] = useState("");
  const [lastWorkingDay, setLastWorkingDay] = useState("");

  useEffect(() => {
    if (isOpen && resignation) {
      setLastWorkingDay(toDateInputValue(resignation.lastWorkingDay));
    }
  }, [isOpen, resignation]);

  if (!isOpen || !resignation) return null;

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit({
      status,
      notes: notes.trim(),
      ...(status === RESIGN_STATUS.APPROVED && lastWorkingDay
        ? { lastWorkingDay }
        : {}),
    });
    setNotes("");
    setStatus(RESIGN_STATUS.APPROVED);
    setLastWorkingDay("");
  }

  function handleClose() {
    setNotes("");
    setStatus(RESIGN_STATUS.APPROVED);
    setLastWorkingDay("");
    onClose();
  }

  return (
    <div className="complaint-modal-overlay" onClick={handleClose}>
      <div className="complaint-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="complaint-modal-title">تحديث حالة الاستقالة</h3>
        <p className="complaint-modal-subtitle">
          الموظف: {resignation.employeeName}
        </p>

        <form onSubmit={handleSubmit}>
          <div className="complaint-modal-field">
            <label className="complaint-modal-label">الحالة الجديدة *</label>
            <select
              className="complaint-modal-select"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              {STATUS_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          {status === RESIGN_STATUS.APPROVED && (
            <div className="complaint-modal-field">
              <label className="complaint-modal-label">آخر يوم عمل *</label>
              <input
                type="date"
                className="complaint-modal-select"
                value={lastWorkingDay}
                min={todayDateInputValue()}
                onChange={(e) => setLastWorkingDay(e.target.value)}
                required
              />
              <p className="complaint-modal-subtitle">
                يُغلق حساب الموظف تلقائياً في هذا اليوم
              </p>
            </div>
          )}

          <div className="complaint-modal-field">
            <label className="complaint-modal-label">ملاحظات (اختياري)</label>
            <textarea
              className="complaint-modal-textarea"
              rows={4}
              placeholder="ملاحظات للموظف..."
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </div>

          <div className="complaint-modal-buttons">
            <button
              type="button"
              className="complaint-modal-btn secondary"
              onClick={handleClose}
            >
              إلغاء
            </button>
            <button type="submit" className="complaint-modal-btn primary">
              حفظ التغيير
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
